'use es6';

import { Fragment } from 'react';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { getFormFieldLabel } from 'FormsUI/utils/FormFieldsUtils';
import Property from 'FormsUI/containers/editor/leftPanel/PropertyDragContainer';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { APPEND_FORM_FIELD } from 'FormsUI/constants/TrackingInteractionKeys/Editor/FormTab';
import { jsx as _jsx } from "react/jsx-runtime";
const GRID_SIZE = {
  xs: 12,
  sm: 12,
  md: 10,
  lg: 10,
  xl: 10
};
const checkIsPropertyRequired = (requiredProperties, objectTypeId, name) => {
  if (requiredProperties[objectTypeId]) {
    return Boolean(requiredProperties[objectTypeId][name]);
  }
  return false;
};
const PropertyFieldsList = ({
  properties = [],
  formLanguage = 'en',
  usedFormFieldIds = {},
  requiredProperties = {},
  disableProperties = false,
  updateDraggedItem = () => {},
  appendFormFieldGroup = () => {},
  isFormLabelPropertyEnabled = false
}) => /*#__PURE__*/_jsx(Fragment, {
  children: /*#__PURE__*/_jsx(Grid, {
    "data-test-id": "draggable-property-fields",
    children: properties.filter(property => !property.hidden).map(property => {
      const {
        objectTypeId,
        name,
        label,
        fieldType
      } = property;
      const id = `${objectTypeId}/${name}`;
      const required = checkIsPropertyRequired(requiredProperties, objectTypeId, name);
      return /*#__PURE__*/_jsx(GridItem, {
        "data-test-id": "draggable-property-field-container",
        size: GRID_SIZE,
        children: /*#__PURE__*/_jsx(Property, {
          id: id,
          name: name,
          required: required,
          fieldType: fieldType,
          handleDrag: updateDraggedItem,
          objectTypeId: objectTypeId,
          label: getFormFieldLabel(sanitize(label, config.TEXTONLY), formLanguage),
          handleClick: () => {
            trackEditorInteraction(APPEND_FORM_FIELD, {
              field_type: id
            });
            appendFormFieldGroup(id);
          },
          isFormLabelPropertyEnabled: isFormLabelPropertyEnabled,
          disabled: Object.prototype.hasOwnProperty.call(usedFormFieldIds, id) || disableProperties
        })
      }, `${name}-${label}-${id}`);
    })
  })
});
export default PropertyFieldsList;